module.exports = __webpack_public_path__ + "img/lg_ring_y_o_null_null@2x.5b3d69ea.png";